import Styles from './WorkflowBuilderItem.module.scss'
import { fillColor } from 'common/PropertyForm/ColorInput'
import { observer } from 'mobx-react-lite'
import { State } from 'stores/Workflows/State'

export interface Props {
  state: State
}

export const Chip = observer(({ state }: Props) => (
  <span className={Styles.chip} style={{ backgroundColor: state.color, color: fillColor(state.color) }}>
    {state.value}
  </span>
))
